// extracted by mini-css-extract-plugin
export default {"desktop":"desktop__lYFaB","burgerOpen":"burgerOpen__KO6zV","icon":"icon__GiwvJ","burgerClose":"burgerClose__4QRfb","light":"light__1GZRo","dark":"dark__Mxi7u"};